import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import '@progress/kendo-theme-default/dist/all.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSelector } from 'react-redux';
import { Pagination } from 'antd';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import InquiryTable from './Common/InquiryTable';
import FollowupDetails from './Common/FollowupDetails';
import SelectList from './Common/SelectList';
import AlertMessage from './Common/AlertMessage';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const AllInquiry = ({ isShow, setIsShow }) => {
    const enquiryTable = [
        {
            Sno: 1,
            member: 'Shila',
            mobile: '9843125743',
            consultant: 'Maria',
            pkg: 'Weight Loss',
            fee: 3000,
            date: '2077-11-12',
            status: 'hold',
            fDate: '2077-11-12',
        },
        {
            Sno: 2,
            member: 'Shila',
            mobile: '9843542743',
            consultant: 'Maria',
            pkg: 'Weight Loss',
            fee: 3000,
            date: '2077-11-12',
            status: 'hold',
            fDate: '2077-11-12',
        },
        {
            Sno: 3,
            member: 'Shila',
            mobile: '9843265743',
            consultant: 'Maria',
            pkg: 'Weight Gain',
            fee: 2500,
            date: '2077-11-12',
            status: 'hold',
            fDate: '2077-11-12'
        }

    ];

    const [data, setData] = useState(enquiryTable);
    const [isDetails, setIsDetails] = useState(false);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dataRef = React.createRef();
    const { alert } = useSelector(state => state.alert);

    const isDelete = (item) => {
        const newData = data.filter(e => { return e.Sno !== item.Sno });
        setData(newData)
    };

    const handleDelete = (item) => {
        confirmAlert({
            message: "Are you sure you want to Delete?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => isDelete(item)
                },
                {
                    label: 'Cancel',
                    onClick: () => null
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        })
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <div className='page_first_div '>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div'>
                <p className='page_topic inline-block'>All Enquiries</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/enquiry/" className='link block text-white text-sm'>
                        <i className="fa-solid fa-square-plus mr-1"></i>
                        Add
                    </Link>
                </div>
                <section className='page_section min-h-[23rem]'>

                    {/* showing success message when form updated */}
                    {alert && <AlertMessage />}

                    {/* selectors and search */}
                    <form className='flex flex-col justify-center px-4 xsm:px-8 lg:flex-row 2xl:justify-start items-center flex-wrap gap-4 py-4 '>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Consultant--</option>
                                <option value="Maria" className=''>Maria</option>
                                <option value="Hemant">Hemant</option>
                                <option value="Rajiv">Rajiv</option>
                                <option value="Sharan">Sharan</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Package--</option>
                                <option value="Weight Loss" >Weight Loss</option>
                                <option value="Weight Gain">Weight Gain</option>
                            </select>
                        </div>
                        <div className='font-lato text-sm xsm:text-base w-full lg:w-80'>
                            <DatePicker placeholder='Follow-up/Enquiry Date' format="dd MMMM yyyy" className='date_picker' />
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Enquiry status--</option>
                                <option value="Hold" >Hold</option>
                                <option value="Done">Done</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select status--</option>
                                <option value="Active" >Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </form>

                    {/* show option and convert buttons */}
                    <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
                        <SelectList
                            setPostPerPage={setPostPerPage}
                            data={data}
                        />
                        <ConvertButtons
                            data={data}
                            ref={dataRef}
                        />
                    </div>
                    {/* all enquiry table data details */}
                    <InquiryTable
                        data={currentPost}
                        sortData={data}
                        setData={setData}
                        onDelete={handleDelete}
                        isDetails={isDetails}
                        setIsDetails={setIsDetails}
                        searchTerm={searchTerm}
                        ref={dataRef}
                    />

                    {/* pagination and table length */}
                    <div className='px-4 xsm:px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>
                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </section>
            </div>
            <Footer />
            <FollowupDetails isDetails={isDetails} setIsDetails={setIsDetails} />
        </div>
    )
}

export default AllInquiry;